import React, { Component } from 'react';
import ReCAPTCHA from "react-google-recaptcha";

const GoogleReCaptchaAPIKEY = '6LdOFbYUAAAAANCAQ3n-0fCDwDEKpbUTRDCM1QBt';


class Form extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      name: '',
      phone: '',
      request: '',
      share: 'public',
      type: 'prayer-request',
      requestValid: false,
      formValid: false,
      errors: {},
      captcha: null,
      isInIframe: (window.self !== window.top) ? true : false
    }
  }

  handleUserInput(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value });
  }

  validate() {

    let errors = {};
    let hasError = false;
    let captchaAnswer = 2.5;

    // Captcha
    if (this.state.isInIframe != true) { // No Recatcha in iframes
      if (!this.state.captcha) {
        errors.captcha = 'Please verify you are a human.';
        hasError = true;
      } else if (this.state.captcha.length <= 0) {
        errors.captcha = 'Please verify you are a human.';
        hasError = true;
      }
    }
    // else if(this.state.captcha != captchaAnswer){
    //     errors.captcha = 'Please answer the question correctly.';
    //     hasError = true;
    // }


    // Email
    if (this.state.email) {

      let emailValid = this.state.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
      if (!emailValid) {
        errors.email = 'Not a valid email';
        hasError = true;
      }

    }

    if (this.state.request.length <= 0) {
      errors.request = 'Please enter a request';
      hasError = true;
    }

    if (hasError) {
      this.setState({ errors: errors });
      return false;
    }
    return true;

  }

  submit(e) {
    e.preventDefault();

    if (!this.validate()) return;

    this.props.onSubmit(this.state);
  }

  handleReCaptchaChange(value) {
    this.setState({ captcha: value });
    if (this.validate()) {
      const errors = { ...this.state.errors };
      errors.captcha = null;
      this.setState({ errors: errors });
    }

  }

  render() {

    let emailStyles = 'form-field -half';
    if (this.state.errors.email) emailStyles += ' -error';

    let requestStyles = 'form-field';
    if (this.state.errors.request) requestStyles += ' -error';

    let captchaStyles = 'form-field';
    if (this.state.errors.captcha) captchaStyles += ' -error';

    return (
      <form className="prayer-request-form" onSubmit={(e) => this.submit(e)}>

        <div className={emailStyles}>

          <label htmlFor="email">Email address</label>

          <input type="email" placeholder="Email address" className="form-control" name="email" onChange={(event) => this.handleUserInput(event)} />

          {(this.state.errors.email && (<span className="error">{this.state.errors.email}</span>))}

        </div>

        <div className="form-field -half">

          <label htmlFor="name">Name</label>

          <input type="text" placeholder="Your name" className="form-control" name="name" onChange={(event) => this.handleUserInput(event)} />

        </div>

        <div className="form-field -half">

          <label htmlFor="phone">Phone</label>

          <input type="text" placeholder="Phone" className="form-control" name="phone" onChange={(event) => this.handleUserInput(event)} />

        </div>

        <div className="form-field -half">

          <label htmlFor="phone">Share this</label>

          <select className="form-control" name="share" onChange={(event) => this.handleUserInput(event)}>
            <option value="public">Publicly</option>
            <option value="anonymous">Anonymously</option>
            <option value="private">Don't Share</option>
          </select>

        </div>

        <div className="form-field">

          <label htmlFor="phone">Prayer Request or Praise Report</label>

          <select className="form-control" name="type" onChange={(event) => this.handleUserInput(event)}>
            <option value="prayer-request">Prayer Request</option>
            <option value="praise-report">Praise Report</option>
          </select>

        </div>

        <div className={requestStyles}>

          <label htmlFor="phone">Your Request</label>

          <textarea name="request" required placeholder="Your prayer request" className="form-control" onChange={(event) => this.handleUserInput(event)}></textarea>
          {(this.state.errors.request && (<span className="error">{this.state.errors.request}</span>))}

        </div>



        {this.state.isInIframe != true && (
          <div className={captchaStyles}>
            <ReCAPTCHA
              sitekey={GoogleReCaptchaAPIKEY}
              onChange={(value) => this.handleReCaptchaChange(value)}
            />
            {(this.state.errors.captcha && (<span className="error">{this.state.errors.captcha}</span>))}
          </div>
        )}
        <div className="form-field"><button type="submit" className="button-primary">Submit</button></div>

      </form>
    )
  }
}
export default Form;
/*
 <div className={captchaStyles}>
         <label htmlFor="phone">What is 10 - 7.5?</label>
         <input type="text" placeholder="A simple test" className="form-control" name="captcha" onChange={(event) => this.handleUserInput(event)} required/>
         {(this.state.errors.captcha && (<span className="error">{this.state.errors.captcha}</span>))}
       </div>*/